import styled from 'styled-components';

export const OptionCheckmarkStyles = styled.div<{
  checked: boolean;
  theme: 'light' | 'dark' | 'dark-forest' | 'domination';
}>`
  width: 20px;
  height: 20px;
  border-radius: 10px;
  border: 1px solid #c7c7cc;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;

  ${(props) =>
    props.checked &&
    props.theme === 'light' &&
    `
        background: linear-gradient(90deg, #7f36f3 0%, #ed0d80 100%);
        border: none;
  `}

  ${(props) =>
    props.checked &&
    props.theme === 'dark' &&
    `
        background: linear-gradient(95.02deg, #D9002F 0%, #7F001C 100%);
        border: none;
  `}

  ${(props) =>
    props.checked &&
    props.theme === 'dark-forest' &&
    `
      background: linear-gradient(272.88deg, #686DE0 4.95%, #4834D4 93.62%);
      border: none;
  `}
`;
